import React from 'react';
import { useTranslation } from 'react-i18next';
import universityImgSrc from 'asset/image/01MainSymb.jpg';
import { styled } from 'styled-components';

const StyledArticle = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 10px;
  &.university > img {
    width: 192px;
    height: 192px;
    @media (max-width: 768px) {
      width: 96px;
      height: 96px;
    }
  }
`;

const SectionEducation = () => {
  const { t } = useTranslation();
  return (
    <div>
      <StyledArticle className="university">
        <img src={universityImgSrc} alt="01MainSymb" />
        <dl>
          <dt>{t('university_name')}</dt>
          <dd>2017.03 - 2021.02</dd>
          <dd>{t('universityMajor_one')}</dd>
          <dd>{t('universityMajor_two')}</dd>
          <dd>{t('universityMinor')}</dd>
        </dl>
      </StyledArticle>
    </div>
  );
};

export default SectionEducation;
